/**
 * @description Toast
 */

import Toastify from 'toastify-js'

window.addEventListener('toast:show', (event) => {
  const { message, hideAfter, type } = event.detail

  Toastify({
    text: message,
    duration: hideAfter,
    close: false,
    gravity: "top",
    position: "right",
    style: {
      background: "inherit",
    },
    className: [
      '!rounded-sm',
      '!shadow-none',
      '!p-4',
      '!py-3',
      '!border',
      type === 'success' ? '!bg-green-500 !border-green-500' : '!bg-red-500 !border-red-500'
    ].join(' ')
  }).showToast();
});

window.dispatchEvent(new CustomEvent("toast:init"));